<template>
	<div class="title-page">
		<h1 class="title">Mes partages</h1>
		<router-link to="/mes-partages/ajouter" class="button outline normal">Créer un partage</router-link>
	</div>
	<div class="card white large no-pdg">
		<div class="file-ctn">
			<h2>Liste de mes partages</h2>
		</div>
		<div v-if="partages.length == 0" style="text-align: center; padding: 50px">
			<h2>Aucun partage pour le moment</h2>
			<img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png" alt="Aucun partage trouvé" />
		</div>
		<div v-else-if="filteredShares.length == 0" style="text-align: center; padding: 50px">
			<h2>Aucun partage trouvé</h2>
			<img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png" alt="Aucun partage trouvé" />
		</div>
		<div v-else class="category">
			<h3 @click="toggleCategoryVisibility('all')">
				Tous mes partages
				<i class="bi"
					:class="{ 'bi-caret-right-fill': !visibleCategories['all'], 'bi-caret-down-fill': visibleCategories['all'] }"></i>
			</h3>
			<div v-if="visibleCategories['all']" class="types">
				<div class="card white pdg-25" v-for="partage in filteredShares" :key="partage.ID">
					<div class="title-ctn">
						<h4>{{ partage.name }}</h4>
						<div>
							<i class="file-icon bi bi-pencil-square" @click="openViewPopup(partage)"></i>
							<i class="file-icon bi bi-share" @click="copyLink(partage.ID, $event)"></i>
							<i class="file-icon bi bi-trash-fill" @click="openPopup(partage.ID)"></i>
						</div>
					</div>
					<p class="file-info">Protégé: {{ partage.password ? "Oui" : "Non" }}</p>
					<p class="file-info">
						Expiration: {{ partage.expiration ? formatDate(partage.expiration) : "Non fournie" }}
					</p>
					<div v-for="file in partage.files.filter(file => file !== null)" :key="file.ID" class="file-entry">
						<i v-if="file.name.toLowerCase().endsWith('.pdf')" class="bi bi-file-pdf-fill"></i>
						<i v-else class="bi bi-file-image-fill"></i>
						<p class="file-name">{{ file.name }}</p>
						<i class="file-icon bi bi-download" @click="downloadFile(file.fileID)"></i>
						<i class="file-icon bi bi-eye-fill" @click="viewFile(file.fileID)"></i>
						<i class="file-icon bi bi-trash-fill" @click="openPopup(file.fileID)"></i>
					</div>
				</div>
				<router-link to="/mes-partages/ajouter" class="card transparent">
					<i class="bi bi-plus-circle-dotted" style="font-size: 50px; color: #000"></i>
				</router-link>
			</div>
		</div>
	</div>
	<ConfirmationPopup :isVisible="showPopup" title="Confirmer la suppression"
		message="Êtes-vous sûr de vouloir supprimer ce partage ?" @confirm="deleteShare" @cancel="closePopup">
	</ConfirmationPopup>
	<PartageViewPopup :isVisible="showViewPopup" title="Partage" cancelButtonText="Fermer"
		:partage="this.showViewPartage" :propID="currentProperty.ID" @confirm="closeViewPopup"
		@cancel1="closeViewPopup">
	</PartageViewPopup>
</template>

<script>
import PartageViewPopup from "@/components/PartageViewPopup.vue";
import ConfirmationPopup from "@/components/ConfirmationPopup";

export default {
	name: "MesPartages",
	props: ["currentProperty", "user", "searchQuery"],
	components: {
		ConfirmationPopup,
		PartageViewPopup,
	},
	data() {
		return {
			partages: [],
			partageToDelete: "",
			showPopup: false,
			showViewPartage: {},
			showViewPopup: false,
			visibleCategories: {},
		};
	},
	mounted() {
		if (this.currentProperty && Object.keys(this.currentProperty).length > 0) {
			this.fetchPartages();
		}
		this.$watch("currentProperty", () => {
			if (this.currentProperty && Object.keys(this.currentProperty).length > 0) {
				this.fetchPartages();
			}
		});
	},
	methods: {
		initializeVisibleCategories() {
			this.visibleCategories["all"] = true;
		},
		async fetchPartages() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "partages/p/" + this.currentProperty.ID, { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.error) {
					window.location.href = "/login";
				} else {
					this.partages = data;
					this.initializeVisibleCategories();
				}
			} catch (error) {
				console.error("Une erreur est survenue lors de la requête.");
			}
		},
		toggleCategoryVisibility(categoryName) {
			this.visibleCategories[categoryName] = !this.visibleCategories[categoryName];
		},
		copyLink(shareID, event) {
			const link = "https://app.mondomicil.fr/partage/" + shareID;
			const tempTextArea = document.createElement("textarea");
			tempTextArea.value = link;

			document.body.appendChild(tempTextArea);

			tempTextArea.select();
			document.execCommand("copy");

			document.body.removeChild(tempTextArea);

			const iconElement = event.target;
			iconElement.classList.remove('bi-share');
			iconElement.classList.add('bi-share-fill');

			setTimeout(() => {
				iconElement.classList.remove('bi-share-fill');
				iconElement.classList.add('bi-share');
			}, 2500);
		},
		openPopup(shareID) {
			this.partageToDelete = shareID;
			this.showPopup = true;
		},
		openViewPopup(partage) {
			this.showViewPartage = partage;
			this.showViewPopup = true;
		},
		closeViewPopup() {
			this.fetchPartages();
			this.showViewPartage = {};
			this.showViewPopup = false;
		},
		closePopup() {
			this.showPopup = false;
		},
		formatDate(date) {
			return new Date(date).toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" });
		},
		viewFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "read/" + fileId;
			window.open(url, "_blank");
		},
		downloadFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "download/" + fileId;
			window.open(url, "_blank");
		},
		async deleteShare() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "partages/delete/" + this.partageToDelete, { method: "GET", credentials: "include", });
				if (!response.ok) {
					alert("Erreur : " + this.partageToDelete);
				} else {
					this.closePopup();
					this.partageToDelete = "";
					this.fetchPartages();
				}
			} catch (error) {
				console.log("Une erreur est survenue lors de la requête.");
			}
		},
	},
	computed: {
		filteredShares() {
			const query = this.searchQuery.toLowerCase();
			return this.partages.filter(partage => partage.name.toLowerCase().includes(query));
		}
	},
};
</script>